import api from './api';

// Admin-only S3 browser (superadmin API).
const s3ViewerService = {
    // No bucket → list all buckets: { buckets: [{ name, createdAt }] }
    listBuckets: () =>
        api.get('/admin/s3viewer').then(r => r.data),

    // One level of a bucket's tree: { folders: [{ prefix, name }], files: [{ key, name, size, lastModified }] }
    list: (bucket, prefix = '') =>
        api.get(`/admin/s3viewer?bucket=${encodeURIComponent(bucket)}&prefix=${encodeURIComponent(prefix)}`).then(r => r.data),

    // Recursive search under prefix: { files: [{ key, name, size, lastModified }], truncated }
    search: (bucket, term, prefix = '') =>
        api.get(`/admin/s3viewer?bucket=${encodeURIComponent(bucket)}&search=${encodeURIComponent(term)}&prefix=${encodeURIComponent(prefix)}`).then(r => r.data),

    // One object's content: { body, encoding: 'utf8'|'base64', contentType, size, truncated?, note? }
    getObject: (bucket, key) =>
        api.get(`/admin/s3viewer?bucket=${encodeURIComponent(bucket)}&key=${encodeURIComponent(key)}`).then(r => r.data),

    createFolder: (bucket, prefix, name) =>
        api.post('/admin/s3viewer', { bucket, prefix, name, type: 'folder' }).then(r => r.data),

    createFile: (bucket, prefix, name, content) =>
        api.post('/admin/s3viewer', { bucket, prefix, name, type: 'file', content }).then(r => r.data),

    deleteObject: (bucket, key) =>
        api.delete(`/admin/s3viewer?bucket=${encodeURIComponent(bucket)}&key=${encodeURIComponent(key)}`).then(r => r.data),

    // Delete a folder (every object under the prefix).
    deletePrefix: (bucket, prefix) =>
        api.delete(`/admin/s3viewer?bucket=${encodeURIComponent(bucket)}&prefix=${encodeURIComponent(prefix)}`).then(r => r.data),
};

export default s3ViewerService;
